import { MiddlewareDtoImpl } from '../../../dto/middlewaredto';
import { MiddlewareAPIResponse } from '../../middlewareapiresponse';

export interface DeleteDedicateFlashMessageResponse extends MiddlewareAPIResponse
{
    // getFlashMessageResponseDtos(): FlashMessageDto[];
}

export class DeleteDedicateFlashMessageResponseDtoImpl extends MiddlewareDtoImpl implements DeleteDedicateFlashMessageResponse
{
    // private getFlashMessageDto : FlashMessageDto[];

    // getFlashMessageResponseDtos(): FlashMessageDto[]
    // {
    //     return this.getFlashMessageDto;
    // }

    // setFlashMessageResponseDtos(getFlashMessageDto: FlashMessageDto[])
    // {
    //     this.getFlashMessageDto = getFlashMessageDto;
    // }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/flashmessage/deletededicate/deletededicateflashmessagesresponse.tsx